;(function () {
  if (typeof customElements === 'undefined' || customElements.get('custom-category-slider')) return

  function initVideoControls(host) {
    host.querySelectorAll('.custom-category-slider__card-video-wrap').forEach(function (wrap) {
      const video = wrap.querySelector('.custom-category-slider__card-video')
      const playBtn = wrap.querySelector('.custom-category-slider__video-btn--play')
      const pauseBtn = wrap.querySelector('.custom-category-slider__video-btn--pause')
      if (!video || (!playBtn && !pauseBtn)) return

      const autoplay = wrap.getAttribute('data-video-autoplay') === 'true'
      if (autoplay) {
        if (playBtn) playBtn.classList.add('hidden')
        if (pauseBtn) pauseBtn.classList.remove('hidden')
      } else {
        if (playBtn) playBtn.classList.remove('hidden')
        if (pauseBtn) pauseBtn.classList.add('hidden')
      }

      function onPlay() {
        video.play().catch(function () {})
        if (playBtn) playBtn.classList.add('hidden')
        if (pauseBtn) pauseBtn.classList.remove('hidden')
      }
      function onPause() {
        video.pause()
        if (playBtn) playBtn.classList.remove('hidden')
        if (pauseBtn) pauseBtn.classList.add('hidden')
      }

      video.addEventListener('play', onPlay)
      video.addEventListener('pause', onPause)
      if (playBtn)
        playBtn.addEventListener('click', function (e) {
          e.preventDefault()
          e.stopPropagation()
          onPlay()
        })
      if (pauseBtn)
        pauseBtn.addEventListener('click', function (e) {
          e.preventDefault()
          e.stopPropagation()
          onPause()
        })
    })
  }

  /**
   * Fractional slidesPerView means the last bullet never activates.
   * Only intervene when the slider is scrolled to the very end; otherwise
   * let Swiper handle pagination normally.
   */
  function fixLastBullet(host) {
    if (window.innerWidth > 500) return

    const wrapper = host.querySelector('.swiper-wrapper')
    const container = host.querySelector('.custom-category-slider__swiper')
    if (!wrapper || !container) return

    let raf = null
    let wasAtEnd = false

    function getBullets() {
      return host.querySelectorAll('.swiper-pagination-bullet')
    }

    function isAtEnd() {
      const slides = host.querySelectorAll('.swiper-slide')
      if (!slides.length) return false
      const lastSlide = slides[slides.length - 1]
      const containerRight = container.getBoundingClientRect().right
      return lastSlide.getBoundingClientRect().right <= containerRight + 4
    }

    function sync() {
      raf = null
      const atEnd = isAtEnd()

      if (atEnd && !wasAtEnd) {
        const bullets = getBullets()
        if (bullets.length) {
          for (let i = 0; i < bullets.length; i++) bullets[i].classList.remove('swiper-pagination-bullet-active')
          bullets[bullets.length - 1].classList.add('swiper-pagination-bullet-active')
        }
      }

      wasAtEnd = atEnd
    }

    function requestSync() {
      if (!raf) raf = requestAnimationFrame(sync)
    }

    // Debounced check after momentum scroll settles (Safari)
    let settleTimer = null
    function onScrollSettle() {
      clearTimeout(settleTimer)
      settleTimer = setTimeout(sync, 80)
    }

    container.addEventListener(
      'scroll',
      function () {
        requestSync()
        onScrollSettle()
      },
      { passive: true }
    )
    wrapper.addEventListener('transitionend', requestSync)
    container.addEventListener(
      'touchend',
      function () {
        setTimeout(sync, 300)
      },
      { passive: true }
    )

    // Last bullet click — smoothly scroll last slide into view
    const pagEl = host.querySelector('.custom-category-slider__pagination')
    if (pagEl) {
      pagEl.addEventListener('click', function (e) {
        let b = e.target
        while (b && !b.classList.contains('swiper-pagination-bullet')) b = b.parentElement
        if (!b) return
        const bullets = getBullets()
        if (b !== bullets[bullets.length - 1]) return

        const slides = host.querySelectorAll('.swiper-slide')
        const last = slides[slides.length - 1]
        if (!last) return

        last.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'end' })
        // Sync after scroll animation completes
        setTimeout(sync, 400)
        setTimeout(sync, 700)
      })
    }
  }

  class CustomCategorySlider extends HTMLElement {
    connectedCallback() {
      initVideoControls(this)
      const self = this
      setTimeout(function () {
        fixLastBullet(self)
      }, 200)
    }
  }

  customElements.define('custom-category-slider', CustomCategorySlider)
})()
